import { types, onSnapshot } from "mobx-state-tree";
import { uniq, uniqBy, prop, flatten } from "ramda";

const Selectable = types
  .model("Selectable", {
    selected: types.boolean,
  })
  .actions((self) => ({
    toggleSelected: () => {
      self.selected = !self.selected;
    },
  }));

const DownloadFilter = Selectable.named("DownloadFilter").props({
  title: types.string,
});

const DownloadUrl = Selectable.props({
  id: types.number,
  selected: types.boolean,
  title: types.string,
  type: types.string,
  urls: types.optional(types.array(types.string), []),
});

const DownloadStore = types
  .model({
    filters: types.optional(types.array(DownloadFilter), []),
    urls: types.optional(types.array(DownloadUrl), []),
  })
  .actions((self) => ({
    setFilters: (filters) => {
      self.filters = filters;
    },
    setUrls: (urls) => {
      const links = uniqBy(
        prop("id"),
        urls.map((t) => ({
          id: t.id,
          title: t.title,
          selected: t.selected,
          type: t.type,
          urls: urls.filter((t1) => t1.id === t.id).map((t1) => t1.url),
        }))
      );
      self.urls = links;
    },
  }))
  .views((self) => ({
    links: () => {
      const links = uniq(
        flatten(self.urls.filter((u) => u.selected).map((u) => [...u.urls]))
      );
      return links;
    },
  }));

export const downloadStore = DownloadStore.create();

if (process.env.NODE_ENV === "development")
  onSnapshot(downloadStore, (newSnapshot) => {
    console.log("downloadStore snapshot: ", newSnapshot);
  });
